// Hjälpare för att flytta daterade aktiviteter när en etapps datum ändras (lucka g7).
import { supabase } from "@/integrations/supabase/client";

export interface DatedActivity {
  table: "safety_rounds" | "coordination_meetings";
  id: string;
  label: string;
  dateField: "round_date" | "meeting_date";
  currentDate: string;
}

export const dayDiff = (from: string, to: string): number => {
  const a = new Date(from);
  const b = new Date(to);
  return Math.round((b.getTime() - a.getTime()) / 86_400_000);
};

export const shiftDate = (date: string, days: number): string => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

/** Alla daterade aktiviteter som är taggade mot etappen och ligger framåt i tiden. */
export const loadStageActivities = async (stageId: string): Promise<DatedActivity[]> => {
  const [rounds, meetings] = await Promise.all([
    supabase
      .from("safety_rounds")
      .select("id, name, round_date")
      .eq("stage_id", stageId)
      .not("round_date", "is", null),
    supabase
      .from("coordination_meetings")
      .select("id, meeting_date, participants")
      .eq("stage_id", stageId)
      .not("meeting_date", "is", null),
  ]);

  const list: DatedActivity[] = [];
  (rounds.data || []).forEach((r: { id: string; name: string | null; round_date: string }) =>
    list.push({
      table: "safety_rounds",
      id: r.id,
      label: r.name || "Skyddsrond",
      dateField: "round_date",
      currentDate: r.round_date,
    })
  );
  (meetings.data || []).forEach(
    (m: { id: string; meeting_date: string; participants: string | null }) =>
      list.push({
        table: "coordination_meetings",
        id: m.id,
        label: `Samordningsmöte${m.participants ? ` – ${m.participants}` : ""}`,
        dateField: "meeting_date",
        currentDate: m.meeting_date,
      })
  );
  return list.sort((a, b) => a.currentDate.localeCompare(b.currentDate));
};

/** Flyttar valda aktiviteter lika många dagar som etappen flyttades. */
export const shiftActivities = async (
  activities: DatedActivity[],
  days: number
): Promise<number> => {
  let moved = 0;
  for (const a of activities) {
    const nextDate = shiftDate(a.currentDate, days);
    const { error } =
      a.table === "safety_rounds"
        ? await supabase.from("safety_rounds").update({ round_date: nextDate }).eq("id", a.id)
        : await supabase
            .from("coordination_meetings")
            .update({ meeting_date: nextDate })
            .eq("id", a.id);
    if (!error) moved += 1;
  }
  return moved;
};
